import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-read-only-fields',
  templateUrl: './read-only-fields.component.html',
  styleUrls: ['./read-only-fields.component.scss'],
  standalone: false,
})
export class ReadOnlyFieldsComponent {
  @Input()
  labelText!: string;

  @Input()
  fieldText!: string | number;
}
